$(document).ready(function () {
  $(".fake-images-container").twentytwenty({
    // How much of the before image is visible when the page loads
    default_offset_pct: 0.5,
    // Orientation (horizontal or vertical)
    orientation: "horizontal",
    // Label text for before and after
    before_label: "Before",
    after_label: "After",
    // Enable/disable overlay
    no_overlay: false,
    // Move with handle
    move_with_handle_only: true,
    // Click to move
    click_to_move: false,
  });
});

const gameInfo = [
  {
    designerName: "Chanel",
    productName: "Caviar Quilted Mini Rectangular",
    answer: "right",
  },
  {
    designerName: "Louis Vuitton",
    productName: "Monogram Tuffetage Deauville Cube",
    answer: "right",
  },
  {
    designerName: "Celine",
    productName: "Drummed Calfskin Suede Small",
    answer: "right",
  },
  {
    designerName: "Cartier",
    productName: "18K Yellow Gold Diamond",
    answer: "right",
  },
  {
    designerName: "Saint Laurent",
    productName: "Crinkled Calfskin Matelasse Monogram",
    answer: "right",
  },
  {
    designerName: "Hermes",
    productName: "Togo Birkin 30 Blue",
    answer: "right",
  },
  {
    designerName: "Gucci",
    productName: "Calfskin Small Padlock Shoulder",
    answer: "left",
  },
  {
    designerName: "David Yurman",
    productName: "Sterling Silver Diamond Amethyst",
    answer: "right",
  },
  {
    designerName: "Prada",
    productName: "Saffiano Cuir Medium Double",
    answer: "left",
  },
  {
    designerName: "Chloe",
    productName: "Suede Calfskin Small Faye",
    answer: "right",
  },
];

const designerImages = {
  Chanel: [
    {
      original: "/cdn/shop/files/content-game-2f63cca2f29665c9371732f5ad20028b.jpg",
      fake: "/cdn/shop/files/content-game-b7603376cb781626f8061b861917a400.jpg",
    },
    {
      original: "/cdn/shop/files/content-game-ecb1977ffd21245b7e9d460f44659c2f.jpg",
      fake: "/cdn/shop/files/content-game-6f50d47dc4a71bbcb2adbb264bf067f7.jpg",
    },
    {
      original: "/cdn/shop/files/content-game-5271c5c73d3a1e345bef2707549edc5d.jpg",
      fake: "/cdn/shop/files/content-game-d7150e69367e9d2c55e1d5e2d208b94e.jpg",
    },
    {
      original: "/cdn/shop/files/content-game-a3c101092292fd84af578c7185c5d2fc.jpg",
      fake: "/cdn/shop/files/content-game-07d464844e422cf4648b5923975d0308.jpg",
    },
    {
      original: "/cdn/shop/files/content-game-54aed0f8b4b45a1cba54c96e2fe4026e.jpg",
      fake: "/cdn/shop/files/content-game-cafb897680d05d028b3074f1fcd1cb42.jpg",
    },
  ],
  "Louis Vuitton": [
    {
      original: "/cdn/shop/files/content-game-0bc6c4d009f3a306eae405f3f0800fd0.jpg",
      fake: "/cdn/shop/files/content-game-974ea94607281d352cf18c3f2b256257.jpg",
    },
    {
      original: "/cdn/shop/files/content-game-0c7cbc0a918a6200c7597905fb72a03f.jpg",
      fake: "/cdn/shop/files/content-game-f99b21960d7602400394f2592547b996.jpg",
    },
    {
      original: "/cdn/shop/files/content-game-9a040e017a571d9c2b006f2e6b91201a.jpg",
      fake: "/cdn/shop/files/content-game-bf7b53ceda795c026d8160636cea25a5.jpg",
    },
    {
      original: "/cdn/shop/files/content-game-b69b1fca2cbe7c065801d25f7b74994c.jpg",
      fake: "/cdn/shop/files/content-game-fdbf70c63c9d4d7bdbc03376614c7423.jpg",
    },
  ],
  Prada: [
    {
      original: "/cdn/shop/files/content-game-396c42371628971c8c1f2fb51a0f7625.jpg",
      fake: "/cdn/shop/files/content-game-c95dfeb7b6599991c67a5c9b0b1a9a9e.jpg",
    },
    {
      original: "/cdn/shop/files/content-game-21eb7dabe842f67f9df60838116029a5.jpg",
      fake: "/cdn/shop/files/content-game-e135e5eca15ab25391fd71731ad57adc.jpg",
    },
    {
      original: "/cdn/shop/files/content-game-7720d9cfa8320c5213446ceaa2285a49.jpg",
      fake: "/cdn/shop/files/content-game-fb4abaa1a8f81c9a61ff657b6070f5dd.jpg",
    },
    {
      original: "/cdn/shop/files/content-game-50bb4a7cff71f785d3e66a31d3fdab7c.jpg",
      fake: "/cdn/shop/files/content-game-be52d78bd09b75ef98de03a1218fe7a6.jpg",
    },
    {
      original: "/cdn/shop/files/content-game-880a5769b8109f5a44f0213c0f4d3bc0.jpg",
      fake: "/cdn/shop/files/content-game-e8b4cd2e41a4436eaa238e17526a5cca.jpg",
    },
    {
      original: "/cdn/shop/files/content-game-7f1f02b39af5554399cbeb58427c8889.jpg",
      fake: "/cdn/shop/files/content-game-68c50080c411930d0b54b22c7995825e.jpg",
    },
  ],
  Hermes: [
    {
      original: "/cdn/shop/files/content-game-4359a310a3a1bcd85fa50768be894d34.jpg",
      fake: "/cdn/shop/files/content-game-ab5671a6927c1e55a514bf23d487079c.jpg",
    },
    {
      original: "/cdn/shop/files/content-game-b94448673c175c7ee91d1248cfd15128.jpg",
      fake: "/cdn/shop/files/content-game-5c93f286ea3dd8ffa408b0e7c993ec80.jpg",
    },
    {
      original: "/cdn/shop/files/content-game-ff2d52649422e960a9f46001fe6f6d40.jpg",
      fake: "/cdn/shop/files/content-game-be2596cc72f658d177a0cf823f3455a3.jpg",
    },
    {
      original: "/cdn/shop/files/content-game-c7f4899128155223985bc84f6d440181.jpg",
      fake: "/cdn/shop/files/content-game-2ddf251ab592fb7dcf7cfacc5ffdb053.jpg",
    },
    {
      original: "/cdn/shop/files/content-game-bfdcc7984b215c638fdae759bb151ea1.jpg",
      fake: "/cdn/shop/files/content-game-ab696db0f4e9d61e57cb1b2dbcd6c9ad.jpg",
    },
  ],
  Cartier: [
    {
      original: "/cdn/shop/files/content-game-cf6367fd8dca1df652f35459a5f2e75c.jpg",
      fake: "/cdn/shop/files/content-game-8b3b6b5af44c2f1556c53769ec266cc6.jpg",
    },
    {
      original: "/cdn/shop/files/content-game-b4f52b45c6c4ec2a0648b139759018e4.jpg",
      fake: "/cdn/shop/files/content-game-59c009e74e484d7f9554670c6e97dd39.jpg",
    },
    {
      original: "/cdn/shop/files/content-game-3bba0f3f3449ae23d4155085c8210137.jpg",
      fake: "/cdn/shop/files/content-game-31b7f0dc219d96172f12559aa96a00f4.jpg",
    },
  ],
  Gucci: [
    {
      original: "/cdn/shop/files/content-game-c3455223a4cfda123a643bcfdde4396f.jpg",
      fake: "/cdn/shop/files/content-game-be277095eda3a4f4887155b402092f71.jpg",
    },
    {
      original: "/cdn/shop/files/content-game-7642f3d0faf3e26d9efee6e756a33e46.jpg",
      fake: "/cdn/shop/files/content-game-feea373075e5f524ae35b749c06b8b89.jpg",
    },
    {
      original: "/cdn/shop/files/content-game-989acd8006f9c1e06f6b54857ff92579.jpg",
      fake: "/cdn/shop/files/content-game-ce4e81aee04b01e7ad5110eb5bbc356a.jpg",
    },
    {
      original: "/cdn/shop/files/content-game-548ec093254bfc20cb33914552fc7ac5.jpg",
      fake: "/cdn/shop/files/content-game-0f2acfaad755c6fd1c0daef64f5d5fce.jpg",
    },
    {
      original: "/cdn/shop/files/content-game-0e220c0495c7282432425b333a3db969.jpg",
      fake: "/cdn/shop/files/content-game-9540f307348117e69fea86613f2171e3.jpg",
    },
    {
      original: "/cdn/shop/files/content-game-c766879bdde0eb611d1454a5f1fa3cd5.jpg",
      fake: "/cdn/shop/files/content-game-0e2988258468f9b0b579835151890884.jpg",
    },
  ],
  Celine: [
    {
      original: "/cdn/shop/files/content-game-8a86c9ad9f4884939c3f8c3534b3f816.jpg",
      fake: "/cdn/shop/files/content-game-2bac314277eb7b968fde8a456d80e6e5.jpg",
    },
    {
      original: "/cdn/shop/files/content-game-9270a58517754443152c441ea5bf926f.jpg",
      fake: "/cdn/shop/files/content-game-ae9f68f0f1c5a5bcd9fa31193b889392.jpg",
    },
    {
      original: "/cdn/shop/files/content-game-7c2d6567ea4ecf827756120016b2662d.jpg",
      fake: "/cdn/shop/files/content-game-4e9ef4909a66e6f7c4766eddddd0e98a.jpg",
    },
    {
      original: "/cdn/shop/files/content-game-df81400c87491f98f2275a29b01942b0.jpg",
      fake: "/cdn/shop/files/content-game-89ed645f2193883c935d4690e7731e62.jpg",
    },
    {
      original: "/cdn/shop/files/content-game-774d228d41735bf01a99c26b2e62065e.jpg",
      fake: "/cdn/shop/files/content-game-cf2f5026e50826b0ff6c96eb3c22e8e2.jpg",
    },
  ],
  "Saint Laurent": [
    {
      original: "/cdn/shop/files/content-game-99ca2b8ec2d543f93129d8218ba2f451.jpg",
      fake: "/cdn/shop/files/content-game-7a8719ec54985929a5a63bd06318e1f2.jpg",
    },
    {
      original: "/cdn/shop/files/content-game-cb6200a4a8ea13c06b8832a48756f1f3.jpg",
      fake: "/cdn/shop/files/content-game-7536ef41bba00f0ed5755956b8726d30.jpg",
    },
    {
      original: "/cdn/shop/files/content-game-9b114a4b411530b5f8d2768782e6a1e2.jpg",
      fake: "/cdn/shop/files/content-game-12785f642f57c3a295376d5ee3beb74a.jpg",
    },
    {
      original: "/cdn/shop/files/content-game-03d0f2ad56b37edd6d80da3d78934207.jpg",
      fake: "/cdn/shop/files/content-game-741246f7f6be4bfe54eab908909a19f6.jpg",
    },
    {
      original: "/cdn/shop/files/content-game-2d1ba8ca657cbe4791087f144569204e.jpg",
      fake: "/cdn/shop/files/content-game-398ebdfc49c80f32bb91c7c5da2c6e61.jpg",
    },
    {
      original: "/cdn/shop/files/content-game-154d9c3c57c21d91901b313d2ffca062.jpg",
      fake: "/cdn/shop/files/content-game-64b17bd8bf8b5f849f16f07f817f77e2.jpg",
    },
  ],
  "David Yurman": [
    {
      original: "/cdn/shop/files/content-game-8c15ef4c6996a48a2088380fe3dd6d09.jpg",
      fake: "/cdn/shop/files/content-game-cb43c754b06ff55e17733b398d0bef45.jpg",
    },
    {
      original: "/cdn/shop/files/content-game-966b71308dfe1261bce85adca94a8516.jpg",
      fake: "/cdn/shop/files/content-game-977f9bd4714ad9267040478acc1083d9.jpg",
    },
    {
      original: "/cdn/shop/files/content-game-f08ca994cb7e75b1e73d70d1713ff5c9.jpg",
      fake: "/cdn/shop/files/content-game-f8ba24467eb8540d2b71d3abb406b992.jpg",
    },
  ],
  Chloe: [
    {
      original: "/cdn/shop/files/content-game-761a066196d0b4365bfe20128c3a54e4.jpg",
      fake: "/cdn/shop/files/content-game-79ced5be2ae3cc26bc329b33db3bf9fa.jpg",
    },
    {
      original: "/cdn/shop/files/content-game-eddea710111b1a866da022a80cd01703.jpg",
      fake: "/cdn/shop/files/content-game-1965ad6e5eb4ecff5ea5d9c3da78cde7.jpg",
    },
    {
      original: "/cdn/shop/files/content-game-66e389736136a9642276e7ee8e61ca32.jpg",
      fake: "/cdn/shop/files/content-game-1a9b7290b7743e98d53fb41ffdcd01c3.jpg",
    },
    {
      original: "/cdn/shop/files/content-game-2037e694d4a08f5b9049b0e48c0514dd.jpg",
      fake: "/cdn/shop/files/content-game-c19b43c0305f51c287138279ea1bb625.jpg",
    },
    {
      original: "/cdn/shop/files/content-game-328c832927ee25573a3c1080bab3e340.jpg",
      fake: "/cdn/shop/files/content-game-4d11d5636c3ff1f4bdccac0ee8a8717d.jpg",
    },
  ],
};

document.addEventListener("DOMContentLoaded", function () {
  let authenticImages = [];
  let gameIndex = 0;
  let score = 0;
  const gameContainer = document.getElementById("game-container");
  const questionNumber = document.getElementById("question-number");
  const designerName = document.getElementById("designer-name");
  const productName = document.getElementById("product-name");
  const leftButton = document.getElementById("left-game-button");
  const rightButton = document.getElementById("right-game-button");
  const rightOrWrong = document.getElementById("right-or-wrong");
  const scoreHeading = document.getElementById("score");
  const endSection = document.getElementById("end-section");
  const finalScore = document.getElementById("final-score");
  const imageContainer = document.getElementById("authentic-images-container");
  const facebookButton = document.getElementById("fp-is-this-authentic__facebook-link");
  const xButton = document.getElementById("fp-is-this-authentic__twitter-link");

  function setAuthenticImages(arr) {
    if (!imageContainer) {
      console.error("imageContainer is null! Check the DOM element ID.");
      return;
    }
    authenticImages = arr;
    // Empty the container before appending new images (if needed)
    imageContainer.innerHTML = "";
    // Loop through the authenticImages array to create image elements
    authenticImages.forEach((imageUrl, index) => {
      const imgElement = document.createElement("img");
      imgElement.src = imageUrl?.original; // Replace with dynamic src URL
      imgElement.alt = "Thumbnail of an authentic product, highlighting key features";
      imgElement.width = 60;
      imgElement.height = 60;
      imgElement.classList.add("fp-thumbnail");
      imgElement.tabIndex = 0;
      imgElement.loading = "lazy";
      // Optionally, set the image id if needed for future reference
      imgElement.id = `authentic-image-${index}`;
      // Append the created image to the container
      imageContainer.appendChild(imgElement);
    });
    onThumbnailClick();
  }
  initApp();

  function initApp() {
    // Initial game setup
    setAuthenticImages(designerImages.Chanel);
    questionNumber.textContent = `${gameIndex + 1}. `;
    designerName.textContent = gameInfo[gameIndex].designerName;
    productName.textContent = gameInfo[gameIndex].productName;
  }

  function createEventListeners() {
    document.querySelectorAll(".fp-thumbnail").forEach((thumbnail) => {
      thumbnail.addEventListener("click", onThumbnailClick);
    });
  }
  createEventListeners();

  function onThumbnailClick(event) {
    const clickedElementId = event ? event.target.id : 0;
    const index = event ? clickedElementId.replace("authentic-image-", "") : 0;
    const { original, fake } = authenticImages[index];

    const handle = document.querySelector(".twentytwenty-handle");
    const before = document.querySelector(".twentytwenty-before");
    const after = document.querySelector(".twentytwenty-after");
    if (!handle || !before || !after) return;

    initImages(original, fake);

    setTimeout(() => {
      // Remove conflicting styles
      handle.style.removeProperty("left");
      before.style.removeProperty("clip");
      after.style.removeProperty("clip");

      // Apply default styles
      handle.style.left = "50%";
      before.style.clip = "rect(0px, 379px, 758px, 0px)";
      after.style.clip = "rect(0px, 758px, 758px, 379px)";
    }, 10);
  }

  // Preload images before setting the src to ensure they are loaded
  function preloadImage(url) {
    const img = new Image();
    img.src = url;
    return img;
  }

  // Function to initialize the images with smooth transition
  function initImages(image1, image2) {
    // Validate inputs to ensure images are valid
    if (!image1 || !image2) {
      console.error("Both image1 and image2 must be valid URLs.");
      return;
    }
    const before = document.querySelector(".twentytwenty-before");
    const after = document.querySelector(".twentytwenty-after");
    // Check if elements exist before proceeding
    if (before && after) {
      // Preload the new images
      const preloadedBefore = preloadImage(image1);
      const preloadedAfter = preloadImage(image2);
      // Wait for the images to load before changing the source
      preloadedBefore.onload = () => {
        before.src = preloadedBefore.src; // Update the "before" image
      };
      preloadedAfter.onload = () => {
        after.src = preloadedAfter.src; // Update the "after" image
      };
      // Once the images are loaded, make them fade back in after a short delay
      setTimeout(() => {
        before.style.opacity = 1;
        after.style.opacity = 1;
      }, 100);
    } else {
      console.error("Could not find elements with the specified classes.");
    }
  }

  function changeImage(index) {
    const designerName = gameInfo[index === 10 ? 9 : index].designerName;
    const images = designerImages[designerName];
    if (images) {
      setAuthenticImages(images);
    } else {
      console.error(`No images found for designer: ${designerName}`);
    }
  }

  const onGameButtonClick = (event) => {
    const selectedAnswer = event.target.value;
    // Move to the next image
    changeImage(gameIndex === 0 ? 1 : gameIndex + 1);
    const { answer } = gameInfo[gameIndex];
    // Update score based on the answer
    const isCorrect = selectedAnswer === answer;
    if (isCorrect) {
      score++;
      rightOrWrong.textContent = "Nicely done!";
    } else {
      rightOrWrong.textContent = "Sorry, that was not correct.";
    }
    // Update score heading
    scoreHeading.textContent = `${score} out of ${gameIndex + 1} correct.`;
    // Clear feedback text after 1 second
    setTimeout(() => (rightOrWrong.innerHTML = ""), 1000);
    // Proceed to the next question or end the game if there are no more questions
    if (gameIndex < gameInfo.length - 1) {
      gameIndex++;
      updateQuestionDetails(gameIndex);
    } else {
      endGame();
    }
    // Blur buttons to remove focus state
    leftButton.blur();
    rightButton.blur();
  };

  // Separate function for updating question details
  const updateQuestionDetails = (index) => {
    questionNumber.textContent = `${index + 1}. `;
    designerName.textContent = gameInfo[index].designerName;
    productName.textContent = gameInfo[index].productName;
    // Reattach event listeners for new game buttons (if needed)
    createEventListeners();
  };

  // Separate function for handling game end logic
  const endGame = () => {
    gameContainer.innerHTML = "";
    endSection.classList.remove("hidden--important");
    finalScore.textContent = `${score} out of ${gameIndex + 1} correct.`;
  };

  if (facebookButton) {
    facebookButton.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      FB.ui({
        method: "share_open_graph",
        action_type: "og.shares",
        action_properties: JSON.stringify({
          object: {
            "og:url": "https://account.fashionphile.com/is-this-authentic",
            "og:title": `I scored ${score} out of 10!`,
            "og:description": "Think you can do better? Test your eye for authentic designer items!",
            "og:image": "https://account.fashionphile.com/images/is-this-authentic.jpg",
          },
        }),
      });
    });
  }

  if (xButton) {
    xButton.addEventListener("click", function (e) {
      e.preventDefault();
      // Customize your message and URL
      const text = encodeURIComponent(`I just scored ${score} out of 10 on Fashionphile's Authenticity Game!`);
      const url = encodeURIComponent("https://account.fashionphile.com/is-this-authentic");
      const hashtags = "AuthenticOrNot,Fashionphile"; // Optional
      const via = "FASHIONPHILE"; // Your Twitter handle without @
      const shareUrl = `https://twitter.com/intent/tweet?text=${text}&url=${url}&hashtags=${hashtags}&via=${via}`;
      // https://twitter.com/intent/tweet?text=I+just+scored+{{ $score }}+out+of+{{ $count }}&url={{ urlencode('https://account.fashionphile.com/is-this-authentic') }}&hashtags=spotthefake"
      // Open the share dialog in a new window
      window.open(shareUrl, "_blank", "width=600,height=400");
    });
  }

  // Button click event listeners
  leftButton.addEventListener("click", onGameButtonClick);
  rightButton.addEventListener("click", onGameButtonClick);
});
